import { render, staticRenderFns } from "./PpContentPage.vue?vue&type=template&id=0960e685&scoped=true&"
import script from "./PpContentPage.vue?vue&type=script&lang=js&"
export * from "./PpContentPage.vue?vue&type=script&lang=js&"
import style0 from "./PpContentPage.vue?vue&type=style&index=0&id=0960e685&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0960e685",
  null
  
)

export default component.exports